import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponentLatLngPipe } from './lib/address-component-lat-lng.pipe';
import { DurationMinutesPipe } from './lib/duration-minutes.pipe';
import { FormatSurveyTaskPipe } from './lib/format-survey-task.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AddressComponentLatLngPipe,
    DurationMinutesPipe,
    FormatSurveyTaskPipe,
  ],
  exports: [
    AddressComponentLatLngPipe,
    DurationMinutesPipe,
    FormatSurveyTaskPipe,
  ],
})
export class VmsPipesModule {}
